import React, { useState, useEffect } from "react";
import axios from "axios";
import CategoryTable from "../../Utills/Table/CategoryTable";
import Category from "../../components/Modal/Category/AddCategoryModal";
import Switch from "@mui/material/Switch";

const CategoryPage = ({ check, change }) => {
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);

  useEffect(() => {
    if (loading) {
      axios
        .get("https://tsetsegtuw.templateapi.xyz/categories")
        .then((e) => setCategory(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);
    
  
  if (loading) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">
      <div className="w-full flex justify-end mb-4 items-center">
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
        <Category />
      </div>
      <div className="w-full max-w-7xl">
        <CategoryTable categories={category} />
      </div>
    </div>
  );
};

export default CategoryPage;
